export default "__VITE_ASSET__24QHyWdz__"